<template>

  <breadcrumb :links="{'/': 'Home', '/webcam': 'Webcam', 'current': 'immagini'}"></breadcrumb>

  <div class="container-xl p-0 py-sm-2 px-sm-3" id="images_container">
    <div v-for="(image, index) in images" v-bind:key="image.id" :class="'image' + (index == 0 ? ' last_image' : '')">
      <img :src="'https://monitor.protezionecivile.fvg.it/api/images/' + image.id" class="img-fluid rounded" :alt="image.webcam_name">
      <div>{{image.webcam_name}} {{convertTime(image.dt)}}</div>
    </div>
  </div>  

  <app-footer></app-footer>

</template>

<style lang="scss" scoped>
  #images_container {
    .image {
      position: relative;
      width: 50%;
      padding-bottom: 5px;
      float: left;
      div {
        position: absolute;
        bottom: 6px;
        right: 6px;
        color: #eee;
        font-size: 0.7em;
        text-shadow:  -1px 1px 0 #0067b1,
          1px 1px 0 #0067b1,
          1px -1px 0 #0067b1,
          -1px -1px 0 #0067b1;
      }
    }
    .image:nth-child(odd) {
      padding-left: 2px;
    }
    .image:nth-child(even) {
      padding-right: 2px;
    }
    .last_image {
      width: 100%;
    }
  }
</style>

<script>
  import MonitorApi from '@/services/MonitorApi';
  import AppFooter from '@/app-footer.vue'
  import Breadcrumb from '@/components/Breadcrumb'

  export default {
    name: "webcams",
    components: {AppFooter, Breadcrumb},
    data: function() {
      return {
        images: []
      }
    },
    methods: {
      convertTime: function(dt) {
        let time = new Date();
        time.setTime(Date.parse(dt + "Z"));
        const str = time.toLocaleString("it-IT");
        return str.substring(0,str.length-3);
      }
    },
    mounted: async function() {
      this.images = await MonitorApi.getWebcamImages(this.$route.params.id, 5);
    }  
  }
</script>